import { render } from "./bulaInput.vue?vue&type=template&id=4ff70ca6&scoped=true"
import script from "./bulaInput.vue?vue&type=script&lang=js"
export * from "./bulaInput.vue?vue&type=script&lang=js"

import "./bulaInput.vue?vue&type=style&index=0&id=4ff70ca6&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff70ca6"]])

export default __exports__